import { render, staticRenderFns } from "./fbSetting.vue?vue&type=template&id=113d8733&scoped=true&"
import script from "./fbSetting.vue?vue&type=script&lang=js&"
export * from "./fbSetting.vue?vue&type=script&lang=js&"
import style0 from "./fbSetting.vue?vue&type=style&index=0&id=113d8733&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d8733",
  null
  
)

export default component.exports